import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { toast } from 'react-toastify'
import './index.css'
import App from './App.jsx'

// alert를 토스트로 대체 (QA 테스트용)
const originalAlert = window.alert;
const NETWORK_ERROR_PATTERNS = [
  /Network Error/i,
  /ERR_NETWORK/i,
  /ECONNABORTED/i,
];
const NETWORK_ERROR_FRIENDLY =
  '네트워크 연결이 불안정합니다. 잠시 후 다시 시도해주세요.';

window.alert = (message) => {
  // 네트워크 에러 백스톱: 원문에 "Network Error" / "ERR_NETWORK" / "ECONNABORTED"가 섞이면
  // 친화 문구로 교체 후 error 토스트로 라우팅
  if (
    typeof message === 'string' &&
    NETWORK_ERROR_PATTERNS.some((re) => re.test(message))
  ) {
    toast.error(NETWORK_ERROR_FRIENDLY, { autoClose: 5000 });
    console.log('[Alert → Toast] (network):', message);
    return;
  }

  // 에러 메시지인 경우 error 토스트, 성공 메시지인 경우 success 토스트
  if (message?.includes('실패') || message?.includes('오류') || message?.includes('에러') || message?.includes('Error')) {
    toast.error(message, { autoClose: 5000 });
  } else if (message?.includes('성공') || message?.includes('완료') || message?.includes('저장')) {
    toast.success(message, { autoClose: 3000 });
  } else {
    toast.info(message, { autoClose: 4000 });
  }
  console.log('[Alert → Toast]:', message);
};

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
